import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
} from './faqs.action';
import { Faq } from './faqs.model';

export interface FaqsRecordsState {
    listData: Faq[];
    singleData: Faq;
    loading: boolean;
    error: any;
}

export const initialState: FaqsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
};


export const faqsRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData }) => {
        return { ...state, listData: listData, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);